module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    attrs: {
      "no-body": "",
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('sidebar.userAdministration'),
      "tab": _vm.namedTab
    }
  })], 1), _vm._v(" "), _c('b-tabs', {
    ref: "tabs",
    attrs: {
      "card": "",
      "lazy": "",
      "pills": "",
      "variant": "danger"
    },
    on: {
      "input": function($event) {
        return _vm.tabChanged()
      }
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [(_vm.hasLocalUserCreatePermission) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[0].title
    }
  }, [_c('local-user-management')], 1) : _vm._e(), _vm._v(" "), (_vm.hasUserCreatePermission) ? _c('b-tab', {
    ref: "tabs",
    attrs: {
      "title": _vm.headers[1].title
    }
  }, [_c('user-management')], 1) : _vm._e(), _vm._v(" "), (_vm.hasLocalUserCreatePermission) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[2].title
    }
  }, [_c('user-create')], 1) : _vm._e(), _vm._v(" "), (_vm.hasNotificationPermissions) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[3].title
    }
  }, [_c('user-notification')], 1) : _vm._e(), _vm._v(" "), (_vm.hasRegistrationReviewAllPermissions) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[4].title
    }
  }, [_c('target-public-users')], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5ce89e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5ce89e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/user-administration/UserAdministration.vue
// module id = 803
// module chunks = 1